<script setup lang="ts">
import InlineNotification from '@/components/notifications/InlineNotification.vue';
import { NotificationMessage } from '@/components/notifications/types.ts';
import { useTranslation } from 'i18next-vue';
import { computed, toRef } from 'vue';
import { useDeviceStatusSignalR } from './utils/useDeviceStatusSignalR';

const props = defineProps<{
  deviceId: string;
}>();

const { t } = useTranslation();

const deviceState = useDeviceStatusSignalR(toRef(() => props.deviceId));

const calibrationMessage = computed<NotificationMessage | undefined>(() => {
  if (deviceState.value?.calibrationState === 'Outdated') {
    return {
      message: t('CalibrationCertificateOutdated'),
      type: 'warning',
    };
  }
  if (deviceState.value?.calibrationState === 'Invalid') {
    return {
      message: t('CalibrationCertificateInvalid'),
      type: 'error',
    };
  }
  return undefined;
});
</script>

<template>
  <InlineNotification :value="calibrationMessage" />
</template>
